var _defs, _path, _path2, _g, _g2, _path3, _rect, _rect2, _path4, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path5, _path6, _ellipse, _circle, _path7, _path8, _path9, _path10, _path11, _g10, _path12, _path13, _path14, _path15, _path16, _ellipse2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse3, _path24, _path25, _ellipse4, _path26, _circle2, _g11, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c1032e23-22c2-4584-afbd-61a2e0c35012",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 881.15,
    height: 664.06,
    viewBox: "0 0 881.15 664.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "467e8b68-45b1-434b-a7f5-b086be41201d",
    x1: 394.53,
    y1: 535.41,
    x2: 400.35,
    y2: 257.9,
    gradientTransform: "matrix(0.07, 1.46, -1, 0.1, 695.7, -227.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d51d3a25-b9a1-448b-87f7-70be68d78674",
    x1: 816.79,
    y1: 533.05,
    x2: 821.71,
    y2: 255.53,
    gradientTransform: "matrix(0.07, 1.36, -1, 0.09, 1155.44, -759.02)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c872033e-8026-499d-b183-701fd90f05a6",
    x1: 588.73,
    y1: 304.93,
    x2: 588.73,
    y2: 246.49,
    gradientTransform: "matrix(1.01, -0.01, -0.01, 1.14, -3.2, -26.24)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3e67b2a-0a76-4c6d-9e5a-373151377d46",
    x1: 585.17,
    y1: 378.05,
    x2: 585.17,
    y2: 319.62,
    gradientTransform: "matrix(1.01, -0.01, -0.01, 1.16, -4.6, -38.03)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b59e7b65-5f81-4602-b2b5-d5b413f47e75",
    x1: 579.06,
    y1: 449.99,
    x2: 579.06,
    y2: 391.55,
    gradientTransform: "matrix(1.01, -0.01, -0.01, 1.18, -1.48, -50.45)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0cab72be-732d-4cb6-98ce-3f72dca88cbf",
    x1: 575.87,
    y1: 549.28,
    x2: 575.87,
    y2: 473.61,
    gradientTransform: "matrix(1.02, -0.01, -0.01, 1.13, -6.89, -41.68)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f2dabbf8-bd88-4491-a058-8d0a9ab39a97",
    x1: 442.26,
    y1: 761.01,
    x2: 442.26,
    y2: 172.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "75d0de0f-1912-4c75-8581-cb1f434aa317",
    x1: 364.25,
    y1: 297.58,
    x2: 364.25,
    y2: 118.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab23c944-d560-40e3-b9b5-e023dff94fba",
    x1: 747.09,
    y1: 766.94,
    x2: 747.09,
    y2: 167.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "596dd8f4-dc4b-482a-b664-9b074aa3c144",
    x1: 905.22,
    y1: 356.85,
    x2: 905.22,
    y2: 145.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#467e8b68-45b1-434b-a7f5-b086be41201d"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "couple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "64b6e542-fbbe-497b-902e-15010a41d72b",
    "data-name": "<Path>",
    d: "M961.22,743.95C854.76,705,794.31,616.56,808,531.12l12.65,140.36c1.93,21.43,3.54,44-10.31,63.77-17.74,25.26-61.47,45.79-99.92,40.47",
    transform: "translate(-155.85 -118.79)",
    fill: "none",
    stroke: "#607d8b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ffeed91e-fa36-4069-908b-8d6c36340b34",
    "data-name": "<Path>",
    d: "M960.37,749.4c-106.46-39-170.9-125.39-157.22-210.83L815.8,678.93c1.93,21.43,3.54,44-10.31,63.77C787.75,768,744,783.49,705.57,778.17",
    transform: "translate(-155.85 -118.79)",
    fill: "none",
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.29
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5fb8c45a-97ec-40ce-8de6-bc3f5f08518a",
    "data-name": "<Rectangle>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.6,
    y: 374.59,
    width: 277.13,
    height: 34.69,
    rx: 5.55,
    ry: 5.55,
    transform: "translate(-242.31 572.7) rotate(-86.21)",
    fill: "url(#467e8b68-45b1-434b-a7f5-b086be41201d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "1e80289f-8a2f-4157-a8bf-c31717633f31",
    "data-name": "<Rectangle>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 677.57,
    y: 377.9,
    width: 277.13,
    height: 32.37,
    rx: 5.55,
    ry: 5.55,
    transform: "translate(213.14 1063.61) rotate(-86.21)",
    fill: "url(#d51d3a25-b9a1-448b-87f7-70be68d78674)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "73b40adb-2b61-4cdc-94e6-31fac3016121",
    "data-name": "<Path>",
    d: "M159.5,743.5C266,704.53,325.9,613,312.22,527.57L299.57,667.93c-1.93,21.43-3.54,44,10.31,63.77,17.74,25.26,61.47,43.79,99.92,38.47",
    transform: "translate(-155.85 -118.79)",
    fill: "none",
    stroke: "#607d8b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.29
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "285fc5cb-aae6-4a2f-b311-1a33d70ca3cf",
    "data-name": "<Rectangle>",
    x: 313.68,
    y: 260.46,
    width: 23.68,
    height: 277.13,
    rx: 5.55,
    ry: 5.55,
    transform: "translate(-128.78 -139.42) rotate(3.79)",
    fill: "#37474f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "1b948749-14dc-4321-9d45-99c62874af4f",
    "data-name": "<Rectangle>",
    x: 804.81,
    y: 262.68,
    width: 23.68,
    height: 277.13,
    rx: 5.55,
    ry: 5.55,
    transform: "translate(-127.56 -171.87) rotate(3.79)",
    fill: "#37474f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "920f3779-138b-4033-8b17-08b8e6be40d1",
    "data-name": "<Path>",
    d: "M159.85,745.84c106.46-39,170.9-125.39,157.22-210.83L304.42,675.38c-1.93,21.43-3.54,44,10.31,63.77,17.74,25.26,61.47,40.79,99.92,35.47",
    transform: "translate(-155.85 -118.79)",
    fill: "none",
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.29
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ae53b15a-0666-42c7-9774-0b75586f7fb1",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.19,312,208.1,318.59c-16.17-1.07-28.41-16.84-27.2-35h0c1.21-18.21,15.42-32.23,31.59-31.16l758.09-6.55c16.17,1.07,28.41,16.84,27.2,35h0C996.57,299.1,982.36,313.12,966.19,312Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#c872033e-8026-499d-b183-701fd90f05a6)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "f836891e-0226-4d83-80e6-73012d451be6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.33,391.31l-761.42,7.54c-16.24-1.08-28.51-17.17-27.28-35.77h0c1.23-18.6,15.52-32.93,31.76-31.86l761.42-7.54c16.24,1.08,28.51,17.17,27.28,35.77h0C994.86,378,980.57,392.38,964.33,391.31Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#b3e67b2a-0a76-4c6d-9e5a-373151377d46)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "fbf5f82d-c22e-4678-ae3c-b7c3ab00a8a7",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.56,469.85,197.5,478.62c-16.16-1.07-28.36-17.42-27.11-36.34h0c1.25-18.92,15.5-33.52,31.66-32.45l758.06-8.76c16.16,1.07,28.36,17.42,27.11,36.34h0C986,456.32,971.72,470.92,955.56,469.85Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#b59e7b65-5f81-4602-b2b5-d5b413f47e75)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "39937586-784e-4453-b9ad-14c761791dad",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.93,311l-750.28.22a29.26,29.26,0,0,1-27.18-31h0a29.26,29.26,0,0,1,31-27.18l750.28-.22a29.26,29.26,0,0,1,27.18,31h0A29.26,29.26,0,0,1,963.93,311Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#e0e0e0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "c03422b0-2e71-4490-8192-410f1daf55aa",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.79,388.62l-750.28.22a29.26,29.26,0,0,1-27.18-31h0a29.26,29.26,0,0,1,31-27.18l750.28-.22a29.26,29.26,0,0,1,27.18,31h0A29.26,29.26,0,0,1,958.79,388.62Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#e0e0e0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "6066eb19-8917-4d49-b655-e0d8fbaaf445",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M953.65,466.24l-750.28.22a29.26,29.26,0,0,1-27.18-31h0a29.26,29.26,0,0,1,31-27.18L957.5,408a29.26,29.26,0,0,1,27.18,31h0A29.26,29.26,0,0,1,953.65,466.24Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#e0e0e0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "05504e63-1d91-4b63-a23e-d66ccf385b3d",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.22,568.93l-748.58,6.66c-20.85-1.38-36.66-21.37-35.13-44.42h0c1.53-23.05,19.83-40.78,40.68-39.4l748.58-6.66c20.85,1.38,36.66,21.37,35.13,44.42h0C987.38,552.58,969.07,570.31,948.22,568.93Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#0cab72be-732d-4cb6-98ce-3f72dca88cbf)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b140f40c-a8b2-4956-ad2e-452fd03b260d",
    "data-name": "<Path>",
    d: "M938.93,566l-734.11,1.29a37.38,37.38,0,0,1-34.73-39.66h0a37.38,37.38,0,0,1,39.66-34.73l734.11-1.29a37.38,37.38,0,0,1,34.73,39.66h0A37.38,37.38,0,0,1,938.93,566Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#37474f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M611.19,319.21c-6.82-6.82-25.87-10.87-38.09-6.62-74.75-36.52-148.47-11.11-181.64,2.53-4.06-2.41-4.4-.15-8.95-1.65a23.28,23.28,0,0,0,3-12.5,24.05,24.05,0,0,0-.42-3.52c28.72-8.17,44.92-29.41,43.7-60.57-1.43-36.55-32.79-65.44-69.34-64s-69,21.6-67.59,58.15c1.12,28.56,14.83,55.74,40.54,64-.37,1.83,4.78.17,4.86,2.13.12,2.95-4.57,9.29-3.51,11.81C301.16,311,292.59,333.4,292.1,365.8a71.25,71.25,0,0,1-1.51,14l-7.2,33.25a65.17,65.17,0,0,0,2.91,37.37c-2.36,3.23-52,72.48,26.67,84.18a92,92,0,0,0,27.22.22c13.22,3.49,26.19,12.91,42.38,34.54,32.11,42.9-5.13,120.93-14.22,138.79-5.45-.92-11.25-.33-15.84,2.68-5.18,3.4-8.23,13.88-6,19.65,1.54,3.95,5.11,6.68,8.61,9.08a163.14,163.14,0,0,0,35.44,18.32c9.2,3.4,20.9,5.45,27.67-1.64s7.44-21.16.27-27.72A47.66,47.66,0,0,0,407,721.33l27.74-99c5.38-29.1,11.43-45.93,6.47-65.39,4,3.83,1.13,1.46,5.16,7C477.53,606.51,427,688.49,427,688.49l-2.1,3.08c-3,1.14-1.1-.2-3.24,2.25-4.08,4.66-9.89,15.22-6.17,20.17,2.54,3.39,4.94,8.62,9,10,12.62,4.3,32.88,7,46.17,8.14,9.77.81,23.37-3.92,28-12.56s-1.46-19.71-10.13-24.11c-5.57-2.82-13.87-4.31-22.42-5.05l22.64-79c17.79-99.24-38.33-130.7-75.93-139.81,3-8.09,3.56-12.45,3.56-12.45h0a63,63,0,0,0,8.89-35.56l-3.56-55.12c-.31-7.9,1.09-9.08-1.78-16,56.68-31.14,131.92-12.57,142-10.39,2.55,4.61,8.59,7.15,14,8.4a93.26,93.26,0,0,0,21.22,2.35c6.55,0,14.18-1.45,17.17-7.27S615.76,323.78,611.19,319.21Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#f2dabbf8-bd88-4491-a058-8d0a9ab39a97)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "af98023a-ba84-4608-aef0-20973dc13f22",
    "data-name": "<Path>",
    cx: 359.84,
    cy: 302.06,
    rx: 19.04,
    ry: 21.05,
    transform: "translate(-167.41 -104.47) rotate(-2.24)",
    fill: "#f5b89c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b4eed79b-84f5-48c3-8b43-45013965af24",
    "data-name": "<Path>",
    cx: 360.89,
    cy: 236.36,
    r: 64.01,
    transform: "translate(-164.83 -104.48) rotate(-2.24)",
    fill: "#f8c198"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "6c542327-4a8e-4472-a7f9-ed6ecee6a014",
    "data-name": "<Path>",
    d: "M372.72,326.31s102.51-55.62,197.8-7.75l-9.92,19.26S468.25,316.19,410,352.24Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "0ebf70c8-58f4-47d0-8dd9-012484bb2b5b",
    "data-name": "<Path>",
    d: "M360.94,490.34l-9.83.39q-1.45.06-2.88,0c-39.25-.25-67.79-37.61-59.49-76l7-32.14a68.85,68.85,0,0,0,1.46-13.54c.48-31.8,14.32-57.16,46.9-58.43l9.83-.39A63.42,63.42,0,0,1,419.55,371l2.1,53.65A63.42,63.42,0,0,1,360.94,490.34Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#35979C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "6d92686d-3b67-484c-b7ef-b32c7ed24186",
    "data-name": "<Path>",
    d: "M382.46,468.88s129.08,1.85,104.74,137.61l-33.68,113-24.87-27.27s47.72-90.46,17.64-131.65-61.4-29.69-61.4-29.69Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "ccb820de-2904-4fa6-ba82-eb5ab7edc6f5",
    "data-name": "<Path>",
    d: "M314.6,462.64s148.63,1.93,120.45,154.41L396.14,744l-28.6-30.6S422.59,611.77,388,565.55s-70.67-33.27-70.67-33.27Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "66820212-e288-4676-a68b-c89a617cd91c",
    "data-name": "<Path>",
    d: "M412.7,459.54,291.64,450.8s-52.17,69.91,25.69,81.49S412.7,459.54,412.7,459.54Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#263238"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "7a4f96e6-2723-4eb9-be60-4d9d5ff4e2f3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.74,124c-4.56-9.22-18.47-5.19-20.68,3.53-5.06,20-26.63,27.68-44.6,31.86-20.77,4.83-42.38,7.15-60.76,18.91-27.26,17.45-33.05,48.51-27.07,77.65a63.48,63.48,0,0,0,6,24.57c5.25,10.73,15.52,17.07,25.87,16.22,4.74,1.46,10.18,1,16.21-2.31,14.21-7.84,23.36-27.12,29.05-41.06,6.28-15.36,13.26-31.06,24.52-43.48,13.36-14.74,27.87-20.94,41.63-35.23C443.27,160.86,448.42,141.58,439.74,124Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#75d0de0f-1912-4c75-8581-cb1f434aa317)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "d00fa5cc-a731-4142-8ea9-b3c3212fb43d",
    "data-name": "<Path>",
    d: "M435.05,129.35c-4.28-8.64-17.31-4.86-19.38,3.31-4.75,18.74-25,25.95-41.81,29.86-19.46,4.53-39.73,6.7-57,17.72-25.55,16.35-31,45.47-25.37,72.79a59.5,59.5,0,0,0,5.66,23c4.92,10.06,14.55,16,24.25,15.2,4.44,1.37,9.54,1,15.19-2.17,13.32-7.35,16.89-25.42,22.23-38.49,5.89-14.4,12.43-29.11,23-40.75,12.53-13.82,31.12-19.62,44-33C438.37,163.86,443.19,145.78,435.05,129.35Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "408e7116-a9b1-46e2-8d7c-02731267a18a",
    "data-name": "<Path>",
    d: "M338.45,334c-13,27.41-38.64,96.83-8.12,131.41,58.77,36.84,4.39-.17,4.39-.17l57.89,41.67a7,7,0,0,0,9-.7l20.62-20.37s-64.2-29.95-61.37-48.52S372.19,343,372.19,343s-.87-19.32-16.48-19.85C349.08,323,341.29,328,338.45,334Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "95055e69-9cf8-4727-b6e6-604bf17a6c9e",
    "data-name": "<Path>",
    d: "M605.56,324.1c4.42,4.42,7.58,11.3,4.72,16.86s-10.26,7-16.59,7a90.14,90.14,0,0,1-20.51-2.27c-6.37-1.46-13.61-4.75-14.64-11.2C554.6,309.9,595.06,313.6,605.56,324.1Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "22e5ffa6-22c1-4fd4-9053-15aaed74771d",
    "data-name": "<Path>",
    d: "M437.36,691c-6,.21-12.15,2.25-16.09,6.76s-5,11.75-1.39,16.53c2.46,3.27,6.49,4.9,10.37,6.22A157.69,157.69,0,0,0,468,728.34c9.45.78,20.87-.35,25.34-8.7s-1.41-19.05-9.79-23.3C472.38,690.67,449.83,690.53,437.36,691Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#37474f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "1f797064-6c59-47bc-afa1-2a232eef37bf",
    "data-name": "<Path>",
    d: "M371.14,710.74c-5.82-1.41-12.31-1.09-17.31,2.19s-8,10-5.78,15.55c1.49,3.81,4.94,6.46,8.32,8.77A157.69,157.69,0,0,0,390.62,755c8.89,3.29,20.2,5.27,26.75-1.59s3.76-18.73-3.18-25.07C405,719.86,383.26,713.67,371.14,710.74Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#37474f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "757ebdc3-d91a-4c9c-a19f-b15bec03743a",
    "data-name": "<Path>",
    cx: 410.24,
    cy: 496.78,
    rx: 22.52,
    ry: 13.11,
    transform: "translate(-174.99 -102.35) rotate(-2.24)",
    fill: "#f8c198"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M897.92,238.39a65.76,65.76,0,0,0-60.49-70.64c-36.21-2.8-75,27.83-77.76,64a65.78,65.78,0,0,0,42.6,66.7,23.49,23.49,0,0,0-.79,17c-3.42,1.13-3.16-1-6.3.7-33.21-14.81-104-39.81-177.36-8.46-10.87-2.65-22.24,16.42-21.75,26.85.21,4.41,4.84,14,8.74,16.05,10,5.35,23.19-3.06,26.67-14.22,15.45-2.56,83.78-15.28,136.42,15.51a59.52,59.52,0,0,0-2.66,8.14c-1.33,5.36,2.22,11-.15,16.37l12.1,49.94c2.25,16.82-.25,30.94,5.42,43.4-1.46.17-3.72,1.54-5.33,1.78-19.2.56-35.18,1.07-53.34,7.11a97.85,97.85,0,0,0-55,47.39c-11.12,21.86-9.57,50.86,7.37,68.6a58.68,58.68,0,0,0,11.29,9.08c.18,1.52.36,3,.58,4.6l22.31,102.25c-2.56,3.47-4.85,6.76-6.69,9.51-3.42,5.11-5.42,11.48-4,17.47S711.89,754.15,718,754c4.21-.08,8-2.47,11.41-4.91a162,162,0,0,0,29.24-26.74,51.92,51.92,0,0,0,6.08-8.65l-2.48,7.2c-3.92,5-7.41,10-10,13.89-3.42,5.11-5.42,11.48-4,17.47s12.13,14.77,18.28,14.65c4.21-.08,8-2.47,11.41-4.91a162,162,0,0,0,29.24-26.74c6.33-7.4,15.8-28.27,11.52-37-3.1-6.33-10.6-8.88-17.76-8.07-4.87-11.71-11.52-17-16.27-36.41,24.6,17.25,48.76,30,78,34.7-23.36-22.11-43.87-47.85-52.08-79-3.53-13.36-4.89-29.22,4.37-39.48,8.56-9.48,22.76-10.5,34.8-14.76,22-7.79,38.61-29.08,40.79-52.34,1.57-16.76-5.42-31.15-20.84-32.14a59.83,59.83,0,0,0,12.77-32.57l5-64.35a60.51,60.51,0,0,0-42.26-62.21,23.54,23.54,0,0,0,.52-14A65.78,65.78,0,0,0,897.92,238.39ZM758.18,688.91a22.13,22.13,0,0,0-16.82,1.29l-.15.09c-5.89-14-17-43.22-20.11-71.93,3.84,1.42,7.66,2.87,11.38,4.47,3.16,1.36,6.27,2.85,9.35,4.42Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#ab23c944-d560-40e3-b9b5-e023dff94fba)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "ca7c05dc-f404-4e8d-be4c-1e094d83bdb3",
    "data-name": "<Path>",
    d: "M814.83,329S714.52,269.5,617.47,313.7l9.18,19.62s93.1-18.09,150,20.15Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "12ac308f-d213-4b28-bd2d-66bb7ba00bd3",
    "data-name": "<Path>",
    d: "M799.66,471.08S670.61,468,689.75,604.6L719.1,718.82,745,692.52s-44.24-92.21-12.61-132.23S794.87,533,794.87,533Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "34d073ed-93e0-40d2-bf9d-1e0ec7d9c259",
    "data-name": "<Path>",
    d: "M600.12,338.16c.2,4.29,2.33,8.66,6.12,10.68,14.81,7.88,30-19.87,22.22-31.16C616.51,300.3,599.53,325.63,600.12,338.16Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "77e53b18-8135-4b7c-bf2d-9edc79e31a86",
    "data-name": "<Path>",
    d: "M710.14,718.57c-3.33,5-5.28,11.17-3.93,17s6.61,10.91,12.6,10.8c4.09-.08,7.77-2.4,11.11-4.78a157.69,157.69,0,0,0,28.46-26c6.16-7.21,11.92-17.13,7.76-25.65s-16.28-10-24.62-5.68C730.38,690,717.08,708.21,710.14,718.57Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "a69cafd2-284f-43ab-88bc-2406ede4d0f3",
    "data-name": "<Path>",
    d: "M864.71,460.07s-148.6-3.74-126.25,149.71l34,128.34,29.75-29.48S751.11,605,787.44,560.11s71.89-30.55,71.89-30.55Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "7b46ea1d-b94b-4df1-9c01-ec19cbf90a19",
    "data-name": "<Path>",
    d: "M815.8,493h0a58.85,58.85,0,0,0,63-54l4.85-62.63a58.85,58.85,0,0,0-54-63h0a58.9,58.9,0,0,0-61.49,44.41,35.08,35.08,0,0,0-.15,15.93l11.78,53.8C777.36,459.67,783.62,490.5,815.8,493Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "151ca525-7bbb-4991-bd6d-1177d2357218",
    "data-name": "<Path>",
    cx: 824.81,
    cy: 308.52,
    rx: 21.05,
    ry: 19.04,
    transform: "translate(297.67 988.25) rotate(-85.57)",
    fill: "#f5b89c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "a5a77078-24df-4f4d-8a14-08c4c7dce91f",
    "data-name": "<Path>",
    d: "M796.4,472.43c-23.87-.09-48.12,1.06-70.77,8.6s-43.78,22.21-54.6,43.49-9.31,49.51,7.17,66.77c14.2,14.87,35.77,19.26,54.66,27.38,43.26,18.59,76.83,59.33,123.32,66.81a170.34,170.34,0,0,1-47.32-79.74c-3.43-13-4.76-28.44,4.25-38.42,8.33-9.23,22.15-10.22,33.87-14.37,21.43-7.58,37.58-28.31,39.7-50.94,1.71-18.24-7-33.6-25.92-31.08C839.44,473.78,817.89,472.51,796.4,472.43Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#35979C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "19d16f3e-009b-494e-97c8-cb0e9a426660",
    "data-name": "<Path>",
    d: "M860.22,345.44s31.38,101.4-4.7,118.23l-56.3,43.79-20.08-24.74s59.71-32.83,66.28-55.05S830,355.82,830,355.82,846.18,331,860.22,345.44Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#f8c198"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "8c292999-a151-4648-b572-b2157f0a066c",
    "data-name": "<Path>",
    cx: 777.73,
    cy: 495.47,
    rx: 12.52,
    ry: 22.35,
    transform: "matrix(0.08, -1, 1, 0.08, 67.84, 1113.83)",
    fill: "#f8c198"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "1eb018fb-882d-4f3a-a894-42ca86384b42",
    "data-name": "<Path>",
    d: "M757.32,731.14c-3.33,5-5.28,11.17-3.93,17s6.61,10.91,12.6,10.8c4.09-.08,7.77-2.4,11.11-4.78a157.69,157.69,0,0,0,28.46-26c6.16-7.21,11.92-17.13,7.76-25.65s-16.28-10-24.62-5.68C777.56,702.56,764.26,720.78,757.32,731.14Z",
    transform: "translate(-155.85 -118.79)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "2fa24866-a44f-4a1f-8078-b896818e272e",
    "data-name": "<Path>",
    cx: 830.08,
    cy: 239.55,
    r: 64.01,
    transform: "translate(371.29 929.86) rotate(-85.57)",
    fill: "#f8c198"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "51f5ebe0-1999-43c0-a732-f2d97e0dabf6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1018.06,273.09c-7.83-7.65-17-13.88-24.63-21.67-7.87-8-13-17.56-17.35-27.82-8.48-20.06-14.31-41.8-29.46-58.2-18.69-20.24-43.54-21.75-69.39-18.24a561.75,561.75,0,0,0-67.79,13.63c-.63-.26-1.24-.53-1.88-.78-12.52-4.71-27.25,2.44-31.73,14.91a24.09,24.09,0,0,0-1.25,10.81c-1.77,3.4-1.69,7.61,1.81,11.31,16.62,17.57,30,34.09,35.71,58,5.31,22.27,12.58,40.38,32,54s42.4,24.37,64.22,33.35c23.6,9.71,48.9,16,74.56,14.11,18.78-1.41,39.71-8.3,49.45-25.73C1043.48,310.74,1033.13,287.8,1018.06,273.09Z",
    transform: "translate(-155.85 -118.79)",
    fill: "url(#596dd8f4-dc4b-482a-b664-9b074aa3c144)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "f5bb29f6-add4-4074-96f2-ee2c4929409b",
    "data-name": "<Path>",
    d: "M1014.51,272.33c-7.58-7.4-16.42-13.44-23.85-21-7.62-7.74-12.6-17-16.8-26.94C965.65,205,960,183.93,945.33,168c-18.1-19.6-42.17-21.06-67.2-17.66a544,544,0,0,0-65.65,13.2c-.61-.25-1.2-.52-1.82-.75-12.13-4.56-26.39,2.36-30.73,14.43a23.33,23.33,0,0,0-1.21,10.47c-1.72,3.3-1.64,7.37,1.75,11,16.1,17,29.06,33,34.59,56.19,5.14,21.57,12.18,39.11,31,52.28s41.06,23.6,62.19,32.29c22.85,9.4,47.35,15.53,72.2,13.66,18.18-1.37,38.46-8,47.89-24.92C1039.12,308.79,1029.1,286.58,1014.51,272.33Z",
    transform: "translate(-155.85 -118.79)",
    fill: "tomato"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.c839bdeb34285dd5af9f0936d180ab3e.svg";
export { ForwardRef as ReactComponent };